<template>
  <div ref="ThePhoneRel" class="ThePhoneRel">
    <a-tooltip
      v-if="hasPhone"
      placement="bottom"
      color="#fff"
      overlayClassName="phoneRelList-tooltip"
    >
      <template #title>
        <div class="phoneRelList-title">
          <span class="phoneRelList-item" v-for="phoneRel in props.phoneRelList" :key="phoneRel">
            <span>{{ phoneRel }}</span>
          </span>
        </div>
      </template>
      <!-- 展示文案 -->
      <div @click="onClick" class="content">
        <span class="display" v-for="(phoneRel, index) in definePhoneRel" :key="phoneRel">
          <span>{{ phoneRel }}</span>
          <span v-if="definePhoneRel.length > ++index">、</span>
        </span>
        <span class="num">关联{{ phoneRelList?.length }}个</span>
      </div>
    </a-tooltip>
    <template v-else>--</template>
  </div>
</template>
<script setup>
import { computed, ref, defineProps, defineEmits } from 'vue'
import { maskPhoneNumber } from '@/utils'

const props = defineProps({
  phoneRelList: {
    type: [Array, null],
    default: () => null
  }
})
// 判断电话是否存在
const hasPhone = computed(() => props.phoneRelList && props.phoneRelList.length)
// 默认展示前2个
const definePhoneRel = computed(() => {
  let arr = []
  if (hasPhone.value) {
    arr = props.phoneRelList.slice(0, 2).map(m => maskPhoneNumber(m))
  }
  return arr
})
const ThePhoneRel = ref(null)
const emit = defineEmits('onClick')
const onClick = () => {
  emit('onClick')
}
</script>
<style lang="scss" scoped>
.ThePhoneRel {
  display: flex;
  .content {
    color: #1890ff;
    cursor: pointer;
    .num {
      font-weight: 500;
    }
  }
}
.phoneRelList-title {
  width: 100%;
  color: #000;
  display: grid;
  grid-column-gap: 12px;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
